import { downloadFromBase64 } from "mkm-avengers";
import useMiddlewareCheck from "./useMiddlewareCheck";
import { useConfig } from "~/constants";

type Statements = {
  [year: number]: {
    [month: string]: {
      docref1_1: string;
      unique_0: string;
      statyear_0: string;
      statmonth_0: number;
    };
  };
};

const useStatements = () => {
  const { baseUrl, headers } = useConfig();

  const state = useState<{
    statements: Statements;
    currentYear: number;
  }>(`useStatements`, () => ({
    statements: {},
    currentYear: 0,
  }));

  const middlewareCheck = useMiddlewareCheck();

  const checkForStatements = async () => {
    try {
      const { data } = await useAsyncData("checkForStatements", () =>
        $fetch<any>(`${baseUrl}/checkForStatements`, {
          headers,
          credentials: "include",
        }),
      );

      return data.value?.hasStatements;
    } catch (error) {
      middlewareCheck.checkIfSessionRelatedIssue(error);
    }
  };

  const getStatements = async () => {
    const { data, error } = await useAsyncData("getStatements", () =>
      $fetch<any>(`${baseUrl}/getStatements`, {
        headers,
        credentials: "include",
      }),
    );

    if (!data.value) {
      useHandleError(error.value);
      return {};
    }

    state.value.statements = data.value.reduce((acc: any, curr: any) => {
      if (!acc[curr["statyear_0"]]) acc[curr["statyear_0"]] = {};
      acc[curr["statyear_0"].toString()][Number(curr["statmonth_0"])] = curr;
      return acc;
    }, {});

    state.value.currentYear = Number(Object.keys(state.value.statements).at(-1));
  };

  const downloadStatementReport = async (statement: any) => {
    if (!statement) return;

    const { data } = await useAsyncData("downloadStatementReport", () =>
      $fetch<any>(`${baseUrl}/downloadStatementReport`, {
        headers,
        credentials: "include",
        body: JSON.stringify({
          docref1: statement.docref1_1,
          unique: statement.unique_0,
        }),
        method: "POST",
      }),
    );

    const pdfData = data.value;
    const { user } = useUser();

    const userName = `${user.value?.profile.first_name}_${user.value?.profile.last_name}`;
    const fileName = `${userName}_statement"_${statement.statyear_0}_${statement.statmonth_0}.pdf`;

    if (pdfData.document) downloadFromBase64(pdfData.document, fileName);
  };

  return {
    checkForStatements,
    getStatements,
    downloadStatementReport,
    ...toRefs(state.value),
  };
};

export default useStatements;
